import "./App.scss";
import { Slider } from "react-fancyslider";

function App() {
  const imgArray1 = [
    "/images/1.jpg",
    "/images/2.jpg",
    "/images/3.jpg",
    "/images/4.jpg",
    "/images/5.jpg",
    "/images/6.jpg",
  ];

  const imgArray2 = [
    "/images/2.jpg",
    "/images/1.jpg",
    "/images/3.jpg",
    "/images/5.jpg",
    "/images/4.jpg",
    "/images/6.jpg",
  ];

  const imgArray3 = [
    "/images/6.jpg",
    "/images/5.jpg",
    "/images/4.jpg",
    "/images/3.jpg",
    "/images/2.jpg",
    "/images/1.jpg",
  ];

  return (
    <div className="App">
      <header className="App-header">Fancy Slider Library Demo</header>
      <main>
        <section className="container1">
          <Slider
            customCss="slider1"
            slideToShow={3}
            images={imgArray1}
            auto={true}
            timer={1000}
            transitionTime={500}
            directionNav={true}
            dotNav={true}
            gap={50}
            aspectRatio="2/2.5"
            animation="fancy"
          />
          <div className="pre">
            <span className="code">
              &#60;Slider customCss="slider1" slideToShow=&#123;3&#125;
              images=&#123;imgArray1&#125; auto=&#123;true&#125;
              timer=&#123;1000&#125; transitionTime=&#123;500&#125;
              directionNav=&#123;true&#125; dotNav=&#123;true&#125;
              gap=&#123;50&#125; aspectRatio="2/2.5" animation="fancy" /&#62;
            </span>
          </div>
        </section>

        <section className="container2">
          <Slider
            customCss="slider2"
            slideToShow={2}
            auto={false}
            animation="fade"
            images={imgArray2}
            timer={2000}
            transitionTime={500}
            directionNav={true}
            dotNav={false}
            gap={80}
            aspectRatio="2/2.5"
          />
          <div className="pre">
            <span className="code">
              &#60;Slider customCss="slider2" slideToShow=&#123;2&#125;
              images=&#123;imgArray2&#125; auto=&#123;false&#125;
              animation="fade" timer=&#123;2000&#125;
              transitionTime=&#123;500&#125; directionNav=&#123;true&#125;
              dotNav=&#123;false&#125; gap=&#123;80&#125; /&#62;
            </span>
          </div>
        </section>

        <section className="container3">
          <Slider
            customCss="slider3"
            slideToShow={1}
            images={imgArray3}
            auto={true}
            animation="slide"
            transitionTime={300}
            directionNav={false}
            dotNav={true}
            aspectRatio="1/1"
          />
          <div className="pre">
            <span className="code">
              &#60;Slider 
              customCss="slider3" 
              slideToShow=&#123;1&#125;
              images=&#123;imgArray3&#125; 
              auto=&#123;true&#125;
              animation="slide" 
              transitionTime=&#123;300&#125;
              directionNav=&#123;false&#125; 
              dotNav=&#123;true&#125; /&#62;
            </span>
          </div>
        </section>
      </main>
    </div>
  );
}

export default App;
